export function HealthIcon({ className }: { className: string }) {
  return (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      fill="currentColor"
    >
      <path d="M93.4,16.2c-10-10-26.1-10-36.1,0l-4.5,4.5l-4.5-4.5c-10-10-26.1-10-36.1,0C7.3,21,5,26.2,5,31.9 c0,4.1,1.1,8.4,3.2,13.1c4.2-2.5,9-4,14.2-4c15.2,0,27.5,12.4,27.5,27.6c0,6.7-2.4,12.8-6.3,17.6c4,3.1,7.3,5,9,5 c5.6,0,32.9-28.5,40.6-38.9C101,42,103.3,26.2,93.4,16.2z" />
      <path d="M22.5,46.1c-4.4,0-8.5,1.3-12,3.5C4.2,53.6,0,60.6,0,68.7c0,12.5,10.1,22.6,22.5,22.6c7,0,13.2-3.2,17.3-8.2 c3.2-3.9,5.2-9,5.2-14.5C45.1,56.2,35,46.1,22.5,46.1z M35.6,73.4h-6.3h-2.2v8.5h-9.3v-8.5H9.4V64h8.4v-3.4v-5h9.3V64h8.4V73.4z" />
    </svg>
  );
}
